import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AttachmentUploadResponse, Chat, Conversation } from 'app/layout/common/quick-chat/quick-chat.types';
import { Observable } from 'rxjs';
import { environment } from '../../../../environment/environment';
import { AuthService } from '../../../core/auth/auth.service';

@Injectable({ providedIn: 'root' })
export class QuickChatService {
    private readonly CHAT_URL = environment.chatUrl;

    constructor(
        private _httpClient: HttpClient,
        private authService: AuthService
    ) {}

    getChats(): Observable<Conversation[]> {
        return this._httpClient.get<Conversation[]>(
            `${this.CHAT_URL}/conversations/${this.authService.getAuthUserIdFromToken()}`
        );
    }

    getChatById(id: string | number): Observable<Chat[]> {
        return this._httpClient.get<Chat[]>(`${this.CHAT_URL}/messages/conversation/${id}`);
    }

    markConversationAsRead(id: string | number): Observable<void> {
        return this._httpClient.post<void>(`${this.CHAT_URL}/messages/conversation/${id}/read`, {});
    }

    getUsersConnect(): Observable<string[]> {
        return this._httpClient.get<string[]>(`${this.CHAT_URL}/connection/active-users`);
    }

    uploadAttachment(file: File, conversationId: number): Observable<AttachmentUploadResponse[]> {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('conversationId', String(conversationId));

        return this._httpClient.post<AttachmentUploadResponse[]>(`${this.CHAT_URL}/files/upload`, formData);
    }

    downloadAttachment(fileKey: string): Observable<Blob> {
        return this._httpClient.get(`${this.CHAT_URL}/files/${fileKey}`, {
            responseType: 'blob',
        });
    }

    createConversation(otherUserId: number): Observable<Conversation> {
        const currentAuthUserId = Number(this.authService.getAuthUserIdFromToken());
        return this._httpClient.post<Conversation>(`${this.CHAT_URL}/conversations/create`, {
            user1: otherUserId,
            user2: currentAuthUserId,
        });
    }
}
